import { render } from "./BusinessSectorsDetails.vue?vue&type=template&id=f79eba22"
import script from "./BusinessSectorsDetails.vue?vue&type=script&lang=js"
export * from "./BusinessSectorsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__